import logo from "../../assets/logo/logo.png";
import "./index.css";

function gotToMainSite() {
  window.location.href = "http://hoghooghyar.com";
}

const Logo = ({ pageName = '' }) => {
  return (
    <div className="Logo flex flex-center">
      <div onClick={gotToMainSite} className="flex column flex-center">
        <img src={logo} alt="حقوق یار" />
        <label className="text-large text-info">حقوق یار</label>
      </div>
      <div className="flex column flex-center mr-4">
        <label>کرم حسین یاری</label>
        <label>وکیل پایه یک دادگستری</label>
        <label>مشاور حقوقی و کیفری</label>
        {pageName.length > 0 ? (
          <label className="border-top">
            {pageName}
          </label>
        ) : null}
      </div>
    </div>
  );
};
export default Logo;
